// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_ResumoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /retomada/resumo (chamado 2026-0052): a meta diaria de contatos e o que ja
 * foi feito hoje.
 *
 * A meta e da UNIDADE (configuracao da franquia, tela Metas Financeiras); com varias
 * franquias no filtro, e a soma delas. `meus_hoje` e de quem esta logado; `unidade_hoje`,
 * de todos. "Hoje" e o dia no fuso da operacao (GMT-3) e vira sozinho a meia-noite.
 *
 * `por_pessoa` (um por pessoa e dia, ultimos 7 dias) so vem para quem gere a unidade
 * (`gestor`): e a visao do franqueado, nao do atendente.
 */
import type { Retomada_ResumoDiaRow } from './Retomada_ResumoDiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Retomada_ResumoResponseDados {
hoje: string
meta_dia: number
meus_hoje: number
unidade_hoje: number
gestor: boolean
por_pessoa: Retomada_ResumoDiaRow[]
}

export type Retomada_ResumoResponse = ApiResponse<Retomada_ResumoResponseDados>;

registerResponseContract('Retomada_ResumoResponse', {
  hoje:         { type: 'string',  required: true },
  meta_dia:     { type: 'number',  required: true },
  meus_hoje:    { type: 'number',  required: true },
  unidade_hoje: { type: 'number',  required: true },
  gestor:       { type: 'boolean', required: true },
  por_pessoa: {
    type: 'array',
    required: true,
    items: {
      dia:      { type: 'string',  required: false },
      owner_id: { type: 'string',  required: false },
      nome:     { type: 'string',  required: false },
      total:    { type: 'number',  required: false },
    },
  },
})
